import { useState } from 'react';

const navLinks = [
  { label: '最新上线', href: '#latest' },
  { label: '题材分类', href: '#genres' },
  { label: '精选片单', href: '#collections' },
  { label: '蓝光专区', href: '#bluray' },
  { label: '排行榜', href: '#charts' },
  { label: '下载指南', href: '#guide' },
  { label: '常见问题', href: '#faq' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="w-full px-4 md:px-6 h-16 flex items-center justify-between gap-4">
        <a href="#home" className="flex items-center gap-2 shrink-0 cursor-pointer">
          <span className="w-9 h-9 rounded-md bg-primary-600 text-background-50 flex items-center justify-center">
            <i className="ri-film-line text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold text-foreground-950 tracking-wide">电影天堂</span>
            <span className="text-[10px] text-foreground-500 tracking-[0.2em] mt-0.5">DYTT · MOVIE HEAVEN</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="px-3 py-2 text-sm text-foreground-700 rounded-md transition-colors hover:text-primary-700 hover:bg-primary-50 cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <span className="flex items-center gap-1.5 text-xs text-secondary-700 bg-secondary-50 border border-secondary-200 px-3 py-1.5 rounded-full">
            <i className="ri-circle-fill text-[8px] text-secondary-500"></i>
            今日已更新 12 部
          </span>
          <a
            href="#latest"
            className="px-4 py-2 text-sm font-medium rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            立即找片
          </a>
        </div>

        <button
          type="button"
          aria-label="打开导航菜单"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-200 text-foreground-800 cursor-pointer"
        >
          <i className={open ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 animate-fade-in">
          <nav className="px-4 py-3 flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="py-3 px-2 text-sm text-foreground-800 border-b border-background-100 last:border-0 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#latest"
              onClick={() => setOpen(false)}
              className="mt-3 py-3 text-center text-sm font-medium rounded-md bg-primary-500 text-background-50 cursor-pointer"
            >
              立即找片
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}